const noteStatusStyles = {
	'abierta': 'bg-amber-50 text-amber-700 ring-amber-200',
	'en seguimiento': 'bg-sky-50 text-sky-700 ring-sky-200',
};

export const StudentNotesPreview = ({ notes = [], totalCount = 0 }) => {
	const items = Array.isArray(notes) ? notes : [];
	const remaining = Math.max(0, Number(totalCount || 0) - items.length);
	return (
		<div className='flex min-w-[240px] max-w-[320px] flex-col gap-2 p-1'>
			<div className='flex items-center justify-between gap-2 border-b border-gray-100 pb-2'>
				<span className='text-xs font-semibold uppercase tracking-wide text-gray-500'>
					Notas activas
				</span>
				<span className='inline-flex items-center rounded-full bg-indigo-50 px-2 py-0.5 text-[11px] font-semibold text-indigo-700 ring-1 ring-inset ring-indigo-200'>
					{totalCount}
				</span>
			</div>
			{
				items.length === 0
					? (
						<p className='py-1 text-center text-xs text-gray-500'>Sin notas disponibles</p>
					)
					: (
						<ul className='flex flex-col gap-1.5'>
							{
								items.map((note, index) => {
									const statusKey = String(note?.status || '').toLowerCase();
									const statusClasses = noteStatusStyles[statusKey] || 'bg-gray-50 text-gray-600 ring-gray-200';
									return (
										<li
											key={note?._id || `${note?.title}-${index}`}
											className='flex items-start gap-2 rounded-md px-1.5 py-1 hover:bg-gray-50'
										>
											<span className='mt-1 inline-flex h-1.5 w-1.5 shrink-0 rounded-full bg-indigo-500'></span>
											<div className='flex min-w-0 flex-1 flex-col'>
												<p className='truncate text-sm font-medium capitalize text-gray-800' title={note?.title}>
													{note?.title || 'Sin título'}
												</p>
												<div className='mt-0.5 flex items-center gap-1.5'>
													<span className={`inline-flex items-center rounded-full px-1.5 py-0.5 text-[10px] font-semibold capitalize ring-1 ring-inset ${statusClasses}`}>
														{note?.status || 'abierta'}
													</span>
													{
														note?.category && (
															<span className='truncate text-[11px] capitalize text-gray-500' title={note.category}>
																{note.category}
															</span>
														)
													}
												</div>
											</div>
										</li>
									);
								})
							}
						</ul>
					)
			}
			{
				remaining > 0 && (
					<p className='border-t border-gray-100 pt-1.5 text-[11px] text-gray-500'>
						y {remaining} {remaining === 1 ? 'nota más' : 'notas más'}
					</p>
				)
			}
		</div>
	);
};
